"use client"

import { LoginErrorPage } from "@bullseye/ui"

export default function Page() {
  return <LoginErrorPage />
}
